import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  CHeader,
  CHeaderToggler,
  CHeaderBrand,
  CHeaderNav,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CSpinner,
  CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilMenu, cilUser, cilAccountLogout, cilChevronBottom } from '@coreui/icons';

const Header = ({ sidebarShow, setSidebarShow, onLogout, user }) => {
  const [logoutLoading, setLogoutLoading] = useState(false);

  const handleLogout = async () => {
    setLogoutLoading(true);
    try {
      await onLogout();
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      setLogoutLoading(false);
    }
  };

  return (
    <CHeader className="bg-primary">
      <CHeaderToggler 
        className="ps-1 text-white border-0 bg-primary" 
        onClick={setSidebarShow}
        style={{ backgroundColor: '#321fdb !important' }}
      >
        <CIcon icon={cilMenu} size="lg" className="text-white" />
      </CHeaderToggler>
      
      <CHeaderBrand className="mx-auto d-md-none text-white">
        Partner Portal - GeoWGS84
      </CHeaderBrand>
      
      <CHeaderBrand className="d-none d-md-flex ms-3 text-white">
        Partner Portal - GeoWGS84
      </CHeaderBrand>
      
      <CHeaderNav className="ms-auto">
        <CDropdown variant="nav-item" alignment="end">
          <CDropdownToggle 
            caret={false} 
            className="text-white bg-primary border-0 d-flex align-items-center"
            style={{ backgroundColor: '#321fdb !important' }}
          >
            <div className="d-flex align-items-center">
              <CIcon icon={cilUser} className="me-2 text-warning" />
              <span className="fw-semibold text-warning">{user?.company_name}</span>

              <CBadge color="warning" className="ms-2" shape="rounded-pill">
                {user?.resellerId}
              </CBadge>
              {/* Added dropdown icon */}
              <CIcon icon={cilChevronBottom} className="ms-2 text-warning" />
            </div>
          </CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem 
              as={Link} 
              to="/profile" 
              className="d-flex align-items-center fw-semibold"
            >
              <CIcon icon={cilUser} className="me-2 text-primary" />
              <span className="text-primary">My Profile</span>
            </CDropdownItem>
            <CDropdownItem 
              onClick={handleLogout} 
              disabled={logoutLoading}
              className="d-flex align-items-center"
            >
              {logoutLoading ? (
                <>
                  <CSpinner size="sm" className="me-2" />
                  <span>Logging out...</span>
                </>
              ) : (
                <>
                  <CIcon icon={cilAccountLogout} className="me-2 text-danger" />
                  <span className="text-danger">Logout</span>
                </>
              )}
            </CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
      </CHeaderNav>
    </CHeader>
  );
};

export default Header;